export { TutorResourcesPage, type TutorResourcesPageProps } from "./TutorResourcesPage"
